import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useDirection } from '../hooks/useDirection';
import { createAppTheme } from '../theme';

/**
 * Nested ThemeProvider that recreates the app theme with the correct MUI
 * `direction` whenever the active language changes. The outer static
 * ThemeProvider in index.tsx keeps CssBaseline happy; this one makes MUI
 * components (Drawer anchor, padding-inline, etc.) RTL-aware at runtime.
 */
export function DirectionProvider({ children }: { children: React.ReactNode }) {
  const dir = useDirection();
  const dirTheme = useMemo(() => createAppTheme(dir), [dir]);
  return <ThemeProvider theme={dirTheme}>{children}</ThemeProvider>;
}
